<template>
    <v-autocomplete
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        cache-items
        clearable
        dense
        hide-no-data
        hide-selected
        outlined
        required
        v-bind="$attrs"
        v-on="$listeners"
    >
        <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
            <slot :name="slot" v-bind="scope"></slot>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    props: {
        api: {
            type: String,
            required: true,
        },
        searchParamName: {
            type: String,
            required: false,
            default: 'search',
        },
    },

    data: () => ({
        entries: [],
        isLoading: false,
        search: null,
    }),

    computed: {
        items() {
            return this.entries;
        },
    },

    watch: {
        search(val) {
            if (!val || val.length < 2) {
                this.entries = [];
                return;
            }

            // Items have already been requested
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;

            let searchParams = {};
            searchParams[this.searchParamName] = val;

            axios
                .get(this.api, {
                    params: searchParams,
                })
                .then((response) => {
                    this.count = response.data.data.length;
                    this.entries = response.data.data;
                })
                .finally(() => (this.isLoading = false));
        },
    },
};
</script>

<style scoped></style>
